<template lang="pug">
    //-----
    //- Отправитель
    //-----
    .tab-content(v-if="recipient && recipient.id" v-loader-overlay="progressRecipient")
        div(v-if="recipient")
            .md-layout.md-gutter
                .md-layout-item.md-caption(v-if="parseInt(recipient.type) === 1 || parseInt(recipient.type) === 3") Юридическое лицо
                .md-layout-item.md-caption(v-if="parseInt(recipient.type) === 2") Физическое лицо
            .md-layout.md-gutter(v-if="parseInt(recipient.type) === 1 || parseInt(recipient.type) === 3")
                .md-layout-item.md-size-50
                    md-field(v-if="recipient.inn")
                        label ИНН
                        md-input(v-model="recipient.inn" name="recipient_inn" v-bind:disabled="true" v-bind:readonly="true")
                .md-layout-item.md-size-50
                    md-field(v-if="recipient.kpp && parseInt(recipient.type) === 1")
                        label КПП
                        md-input(v-model="recipient.kpp" name="recipient_kpp" v-bind:disabled="true" v-bind:readonly="true")
                .md-layout-item.md-size-100
                    md-field(v-if="recipient.name")
                        label Наименование
                        md-input(v-model="recipient.name" name="recipient_name" v-bind:disabled="true" v-bind:readonly="true")
            .md-layout.md-gutter(v-if="parseInt(recipient.type) === 2")
                .md-layout-item.md-size-50
                    md-field(v-if="recipient.name")
                        label ФИО
                        md-input(v-model="recipient.name" name="recipient_name" v-bind:disabled="true" v-bind:readonly="true")
                .md-layout-item.md-size-50
                    md-field(v-if="recipient.passport_number")
                        label Номер паспорта
                        md-input(v-model="recipient.passport_number" name="recipient_passport_number" v-bind:disabled="true" v-bind:readonly="true")

            .md-layout.md-gutter
                .md-layout-item.md-size-50
                    md-field(v-if="recipient.checking_account")
                        label Номер расчётного счёта
                        md-input(v-model="recipient.checking_account" name="recipient_checking_account" v-bind:disabled="true" v-bind:readonly="true")
                .md-layout-item.md-size-50
                    md-field(v-if="recipient.correspondent_account")
                        label Номер корреспонденского счёта
                        md-input(v-model="recipient.correspondent_account" name="recipient_correspondent_account" v-bind:disabled="true" v-bind:readonly="true")
                .md-layout-item.md-size-50
                    md-field(v-if="recipient.bic")
                        label БИК
                        md-input(v-model="recipient.bic" name="recipient_bic" v-bind:disabled="true" v-bind:readonly="true")
                .md-layout-item.md-size-50
                    md-field(v-if="recipient.bank")
                        label Банк
                        md-input(v-model="recipient.bank" name="recipient_bank" v-bind:disabled="true" v-bind:readonly="true")
                .md-layout-item.md-size-50
                    md-field(v-if="recipient.phone")
                        label Телефон
                        md-input(v-model="recipient.phone" name="recipient_phone" v-bind:disabled="true" v-bind:readonly="true")
                .md-layout-item.md-size-50
                    md-field(v-if="recipient.email")
                        label Email
                        md-input(v-model="recipient.email" name="recipient_email" v-bind:disabled="true" v-bind:readonly="true")

            div(v-if="contacts && contacts.length")
                .md-caption Контактные лица
                .md-layout.md-gutter(v-for="(contact, i) in contacts")
                    .md-layout-item.md-size-33(v-if="contact.contact && contact.contact.name"):  span {{contact.contact.name}}
                    .md-layout-item.md-size-33(v-if="contact.contact && contact.contact.phone"): span {{contact.contact.phone}}
                    .md-layout-item.md-size-33(v-if="contact.contact && contact.contact.email"): span {{contact.contact.email}}
</template>
<script>
    import moment from "moment"
    export default {
        name: 'recipient',
        props: {
            id: {
                type: Number,
                default: 0
            },
            deal_id: {
                type: Number,
                default: 0
            }
        },
        components: {},
        data() {
            return {
                recipient: {type: 1, contacts: [], name: ''},
                contacts: []
            }
        },
        computed: {
            progressRecipient() {
                return this.progressObj['load-deal-recipient-card'];
            },
            progressObj() {
                return this.$store.state.progressObj;
            }
        },
        watch: {
            '$props.id'() {
                this.getRecipient();
            },
            '$props.deal_id'() {
                this.getContacts();
            }
        },
        methods: {
            //получение отправителя
            getRecipient() {
                if (!this.$props.id) return;
                this.$store.commit('showProgressBar', 'load-deal-recipient-card');
                this.load_customer = true;
                this.$store.dispatch('customers/getCustomerById', this.$props.id).then(customer => {
                    if (customer) {
                        customer.type = parseInt(customer.type);
                        this.recipient = Object.assign({}, customer);
                    } else this.recipient = { type: 1, contacts: [], name: '' };
                    this.load_customer = false;
                }).finally(() => this.$store.commit('hideProgressBar', 'load-deal-recipient-card'));
            },
            getContacts() {
                if (!this.$props.deal_id) return;
                this.$store.commit('showProgressBar', 'load-deal-recipient-card');
                this.$store.dispatch('deals/getDealContacts', {deal_id: this.$props.deal_id, type: 'recipient'}).then(r => {
                    this.contacts = Object.assign([], r);
                }).finally(() => this.$store.commit('hideProgressBar', 'load-deal-recipient-card'));
            }
        },
        created() {
            this.getRecipient();
            this.getContacts();
        },
    }
</script>



// WEBPACK FOOTER //
// recipient.vue?f0a017f8